import React from 'react';
import { Stack, Typography, FormControlLabel, Radio, Box, Slider, RadioGroup } from '@mui/material';
import { useFormContext, Controller } from 'react-hook-form';
import { useTranslation } from 'services/localization';
import { FormValues } from '../../types';

const Logo = () => {
	const { control } = useFormContext<FormValues>();
	const { t } = useTranslation();

	return (
		<Stack spacing={1}>
			<Stack mt={2}>
				<Typography variant="body2" sx={{ textTransform: 'uppercase', fontWeight: 400 }}>
					{t('channels.online.customizer.header.logoPlacement', 'Logo placement')}
				</Typography>
				<Controller
					control={control}
					name="onlineLayout.header.logo.placement"
					render={({ field }) => {
						return (
							<RadioGroup aria-label="logo-placement" {...field}>
								<FormControlLabel
									value="left"
									control={<Radio />}
									label={t('channels.online.customizer.header.logo.left', 'Left')}
								/>
								<FormControlLabel
									value="centered"
									control={<Radio />}
									label={t('channels.online.customizer.header.logo.centered', 'Centered')}
								/>
							</RadioGroup>
						);
					}}
				/>
			</Stack>
			<Stack>
				<Box mt={3}>
					<Typography
						id="logo-width-label"
						variant="body2"
						sx={{ textTransform: 'uppercase', fontWeight: 400 }}
					>
						{t('channels.online.customizer.header.logo.width', 'Logo width')}
					</Typography>
					<Box sx={{ display: 'flex', flexDirection: 'row', mt: 1 }}>
						<Controller
							control={control}
							name="onlineLayout.header.logo.width"
							render={({ field }) => {
								return (
									<>
										<Slider
											{...field}
											onChange={(_, value) => {
												field.onChange(value);
											}}
											aria-labelledby="logo-width-label"
											getAriaValueText={(value: number) => value.toString()}
											valueLabelDisplay="auto"
											step={5}
											min={20}
											max={300}
										/>
										<Typography ml={2}>{`${field.value}px`}</Typography>
									</>
								);
							}}
						/>
					</Box>
				</Box>
			</Stack>
		</Stack>
	);
};

export default Logo;
